import React from 'react'

import DiseaseDashboard from '../components/DiseaseDashboard'
import ZoomableTableWrapper from '../components/DiseaseDashboard/ZoomableTableWrapper'
import useWebviewPageHeight from './useWebviewPageHeight'

const DiseaseDashboardTablePage = () => {
  const [isLoading, setIsLoading] = React.useState(false)

  // Pinned height, or 0 to render unconstrained — see the hook for why.
  const pageHeight = useWebviewPageHeight()

  // Only clamp height once we have a real pixel value; otherwise render like
  // `main` (auto height) so iOS never blanks on a 0 / unknown viewport.
  const boundedStyle: React.CSSProperties =
    pageHeight > 0 ? { height: pageHeight, overflow: 'hidden' } : {}

  React.useEffect(() => {
    // Lock the native viewport so the WebView's own pinch/double-tap zoom does
    // not fight ZoomableTableWrapper's custom pinch handler. Matches the sibling
    // ข้อมูลบ่อ page (DashboardTablePage); the Lab page previously omitted this.
    const viewport = document.querySelector('meta[name="viewport"]')
    if (!viewport) return
    const original = viewport.getAttribute('content') ?? ''
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no'
    )
    return () => {
      viewport.setAttribute('content', original)
    }
  }, [])

  return (
    <div style={boundedStyle}>
      <ZoomableTableWrapper initialScale={0.5} minScale={0.2} maxScale={1.5} isLoading={isLoading}>
        <DiseaseDashboard setLoadingMobile={setIsLoading} />
      </ZoomableTableWrapper>
    </div>
  )
}

export default DiseaseDashboardTablePage
